import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../_theme/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_1ab001fa from 'nuxt_plugin_plugin_1ab001fa' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_gtm_dfaff504 from 'nuxt_plugin_gtm_dfaff504' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtplugin1e61bf69_0e78e06a from 'nuxt_plugin_nuxtplugin1e61bf69_0e78e06a' // Source: ./nuxt.plugin.1e61bf69.js (mode: 'server')
import nuxt_plugin_pluginutils_c741c2da from 'nuxt_plugin_pluginutils_c741c2da' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_b328cab2 from 'nuxt_plugin_pluginseo_b328cab2' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_91db59c4 from 'nuxt_plugin_pluginrouting_91db59c4' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_3ad2c5de from 'nuxt_plugin_pluginmain_3ad2c5de' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuescrollto_ea98773e from 'nuxt_plugin_vuescrollto_ea98773e' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_ee44f760 from 'nuxt_plugin_cookieuniversalnuxt_ee44f760' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtpluginc964f4f8_41db1da8 from 'nuxt_plugin_nuxtpluginc964f4f8_41db1da8' // Source: ./nuxt.plugin.c964f4f8.js (mode: 'all')
import nuxt_plugin_pluginsi18ncookies5d69bd58_11e68cc7 from 'nuxt_plugin_pluginsi18ncookies5d69bd58_11e68cc7' // Source: ./plugins.i18n-cookies.5d69bd58.js (mode: 'all')
import nuxt_plugin_pluginse2etesting18a4ebdb_0c8136fa from 'nuxt_plugin_pluginse2etesting18a4ebdb_0c8136fa' // Source: ./plugins.e2e-testing.18a4ebdb.js (mode: 'all')
import nuxt_plugin_pluginsloggera1ee5f30_7e5e5090 from 'nuxt_plugin_pluginsloggera1ee5f30_7e5e5090' // Source: ./plugins.logger.a1ee5f30.js (mode: 'all')
import nuxt_plugin_pluginsssr18434778_2941d33c from 'nuxt_plugin_pluginsssr18434778_2941d33c' // Source: ./plugins.ssr.18434778.js (mode: 'all')
import nuxt_plugin_pluginscontext22c8fc07_0167dc8a from 'nuxt_plugin_pluginscontext22c8fc07_0167dc8a' // Source: ./plugins.context.22c8fc07.js (mode: 'all')
import nuxt_plugin_image_725931a3 from 'nuxt_plugin_image_725931a3' // Source: ./image.js (mode: 'all')
import nuxt_plugin_workbox_7d681fc4 from 'nuxt_plugin_workbox_7d681fc4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_249762d7 from 'nuxt_plugin_metaplugin_249762d7' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_cookieStore_59bf1ba7 from 'nuxt_plugin_cookieStore_59bf1ba7' // Source: ../plugins/cookieStore (mode: 'all')
import nuxt_plugin_braintree_38f7bcde from 'nuxt_plugin_braintree_38f7bcde' // Source: ../plugins/braintree (mode: 'all')
import nuxt_plugin_vimeoplayer_c28cd600 from 'nuxt_plugin_vimeoplayer_c28cd600' // Source: ../plugins/vimeo-player (mode: 'all')
import nuxt_plugin_vueplaceholders_1b021dbd from 'nuxt_plugin_vueplaceholders_1b021dbd' // Source: ../plugins/vue-placeholders (mode: 'all')
import nuxt_plugin_meta_7277d8e8 from 'nuxt_plugin_meta_7277d8e8' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Lazzari Store","meta":[{"charset":"utf-8"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"hid":"description","name":"description","content":"Lazzari Store"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fiphone5_splash.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fiphone6_splash.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fiphoneplus_splash.png","media":"(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fiphonex_splash.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fiphonexr_splash.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fiphonexsmax_splash.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fipad_splash.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fipadpro1_splash.png","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fipadpro3_splash.png","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)"},{"name":"apple-touch-startup-image","href":"\u002Fsplash\u002Fipadpro2_splash.png","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)"},{"hid":"og:title","property":"og:title","content":"Lazzari Store"},{"hid":"og:description","property":"og:description","content":"Lazzari Store"},{"hid":"og:site_name","property":"og:site_name","content":"Lazzari Store"},{"hid":"og:image","property":"og:image","content":"\u002Ficons\u002F512x512-with-background.jpg"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fpng","sizes":"180x180","href":"\u002Ficons\u002F180x180.png"},{"rel":"apple-touch-icon","type":"image\u002Fpng","sizes":"120x120","href":"\u002Ficons\u002F120x120.png"},{"rel":"apple-touch-icon","type":"image\u002Fpng","sizes":"167x167","href":"\u002Ficons\u002F167x167.png"},{"rel":"apple-touch-icon","type":"image\u002Fpng","sizes":"152x152","href":"\u002Ficons\u002F152x152.png"},{"rel":"preconnect","href":"https:\u002F\u002Fconsentcdn.cookiebot.com"},{"rel":"preload","as":"script","href":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js?cbid=d8400cd3-b41d-4279-ade1-92487979b2cf"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400&display=swap"}],"script":[{"src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js?cbid=d8400cd3-b41d-4279-ade1-92487979b2cf","defer":true},{"hid":"klaviyo","id":"klaviyo","src":"https:\u002F\u002Fstatic.klaviyo.com\u002Fonsite\u002Fjs\u002Fklaviyo.js?company_id=SSxr2i","async":false,"type":"text\u002Fjavascript"},{"hid":"klaviyo-object","id":"klaviyo-object","src":"\u002Fscripts\u002Fklaviyo.js","type":"text\u002Fjavascript"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-58XBPMQ')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-58XBPMQ&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1ab001fa === 'function') {
    await nuxt_plugin_plugin_1ab001fa(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dfaff504 === 'function') {
    await nuxt_plugin_gtm_dfaff504(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin1e61bf69_0e78e06a === 'function') {
    await nuxt_plugin_nuxtplugin1e61bf69_0e78e06a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c741c2da === 'function') {
    await nuxt_plugin_pluginutils_c741c2da(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_b328cab2 === 'function') {
    await nuxt_plugin_pluginseo_b328cab2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_91db59c4 === 'function') {
    await nuxt_plugin_pluginrouting_91db59c4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_3ad2c5de === 'function') {
    await nuxt_plugin_pluginmain_3ad2c5de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_ea98773e === 'function') {
    await nuxt_plugin_vuescrollto_ea98773e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_ee44f760 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_ee44f760(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginc964f4f8_41db1da8 === 'function') {
    await nuxt_plugin_nuxtpluginc964f4f8_41db1da8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18ncookies5d69bd58_11e68cc7 === 'function') {
    await nuxt_plugin_pluginsi18ncookies5d69bd58_11e68cc7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting18a4ebdb_0c8136fa === 'function') {
    await nuxt_plugin_pluginse2etesting18a4ebdb_0c8136fa(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsloggera1ee5f30_7e5e5090 === 'function') {
    await nuxt_plugin_pluginsloggera1ee5f30_7e5e5090(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsssr18434778_2941d33c === 'function') {
    await nuxt_plugin_pluginsssr18434778_2941d33c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontext22c8fc07_0167dc8a === 'function') {
    await nuxt_plugin_pluginscontext22c8fc07_0167dc8a(app.context, inject)
  }

  if (typeof nuxt_plugin_image_725931a3 === 'function') {
    await nuxt_plugin_image_725931a3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7d681fc4 === 'function') {
    await nuxt_plugin_workbox_7d681fc4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_249762d7 === 'function') {
    await nuxt_plugin_metaplugin_249762d7(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieStore_59bf1ba7 === 'function') {
    await nuxt_plugin_cookieStore_59bf1ba7(app.context, inject)
  }

  if (typeof nuxt_plugin_braintree_38f7bcde === 'function') {
    await nuxt_plugin_braintree_38f7bcde(app.context, inject)
  }

  if (typeof nuxt_plugin_vimeoplayer_c28cd600 === 'function') {
    await nuxt_plugin_vimeoplayer_c28cd600(app.context, inject)
  }

  if (typeof nuxt_plugin_vueplaceholders_1b021dbd === 'function') {
    await nuxt_plugin_vueplaceholders_1b021dbd(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_7277d8e8 === 'function') {
    await nuxt_plugin_meta_7277d8e8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
